import { inject, Injectable } from '@angular/core';
import { SERVICE_CONFIG_TOKEN, ServiceConfig } from '@web/csl-lib-services';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ClinicInboxMessage } from '@web/csl-lib-models';

@Injectable({
  providedIn: 'root'
})
export class ClinicMessagesService {

  private serviceConfig: ServiceConfig;
  private http!: HttpClient;
  private readonly apiUrl! : string;

  constructor() {
    this.http = inject(HttpClient);
    this.serviceConfig = inject(SERVICE_CONFIG_TOKEN);
    this.apiUrl = this.serviceConfig.apiUrl;
  }

  getMessages(clinicId: number): Observable<ClinicInboxMessage[]> {
    return this.http.get<ClinicInboxMessage[]>(`${this.apiUrl}/clinics/${clinicId}/messageindex`);
  }

  getMessage(clinicId: number, messageId: number): Observable<ClinicInboxMessage> {
    return this.http.get<ClinicInboxMessage>(`${this.apiUrl}/clinics/${clinicId}/messages/${messageId}`);
  }

  deleteMessage(clinicId: number, messageId: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.apiUrl}/clinics/${clinicId}/messages/${messageId}`);
  }

  resetMessage(clinicId: number, messageId: number): Observable<ClinicInboxMessage> {
    return this.http.patch<ClinicInboxMessage>(`${this.apiUrl}/clinics/${clinicId}/messages/${messageId}/reset`, {});
  }

  updateUnreadMessageCount(clinicId: number): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/clinics/${clinicId}/unreadmessagecount`);
  }


}
